import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EnvelopeSimpleShippingComponent } from './envelope-simple-shipping.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EnvelopeSimpleShippingComponent],
  exports: [EnvelopeSimpleShippingComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EnvelopeSimpleShippingModule {}
